const mappers = [
  { state: "AK", min: 99501, max: 99950 },
  { state: "AL", min: 35004, max: 36925 },
  { state: "AR", min: 71601, max: 72959 },
  { state: "AR", min: 75502, max: 75502 },
  { state: "AZ", min: 85001, max: 86556 },
  { state: "CA", min: 90001, max: 96162 },
  { state: "CO", min: 80001, max: 81658 },
  { state: "CT", min: 6001, max: 6389 },
  { state: "CT", min: 6401, max: 6928 },
  { state: "DC", min: 20001, max: 20039 },
  { state: "DC", min: 20042, max: 20599 },
  { state: "DC", min: 20799, max: 20799 },
  { state: "DE", min: 19701, max: 19980 },
  { state: "FL", min: 32004, max: 34997 },
  { state: "GA", min: 30001, max: 31999 },
  { state: "GA", min: 39901, max: 39901 },
  { state: "HI", min: 96701, max: 96898 },
  { state: "IA", min: 50001, max: 52809 },
  { state: "IA", min: 68119, max: 68120 },
  { state: "ID", min: 83201, max: 83876 },
  { state: "IL", min: 60001, max: 62999 },
  { state: "IN", min: 46001, max: 47997 },
  { state: "KS", min: 66002, max: 67954 },
  { state: "KY", min: 40003, max: 42788 },
  { state: "LA", min: 70001, max: 71232 },
  { state: "LA", min: 71234, max: 71497 },
  { state: "MA", min: 1001, max: 2791 },
  { state: "MA", min: 5501, max: 5544 },
  { state: "MD", min: 20331, max: 20331 },
  { state: "MD", min: 20335, max: 20797 },
  { state: "MD", min: 20812, max: 21930 },
  { state: "ME", min: 3901, max: 4992 },
  { state: "MI", min: 48001, max: 49971 },
  { state: "MN", min: 55001, max: 56763 },
  { state: "MO", min: 63001, max: 65899 },
  { state: "MS", min: 38601, max: 39776 },
  { state: "MS", min: 71233, max: 71233 },
  { state: "MT", min: 59001, max: 59937 },
  { state: "NC", min: 27006, max: 28909 },
  { state: "ND", min: 58001, max: 58856 },
  { state: "NE", min: 68001, max: 68118 },
  { state: "NE", min: 68122, max: 69367 },
  { state: "NH", min: 3031, max: 3897 },
  { state: "NJ", min: 7001, max: 8989 },
  { state: "NM", min: 87001, max: 88441 },
  { state: "NV", min: 88901, max: 89883 },
  { state: "NY", min: 6390, max: 6390 },
  { state: "NY", min: 10001, max: 14975 },
  { state: "OH", min: 43001, max: 45999 },
  { state: "OK", min: 73001, max: 73199 },
  { state: "OK", min: 73401, max: 74966 },
  { state: "OR", min: 97001, max: 97920 },
  { state: "PA", min: 15001, max: 19640 },
  { state: "RI", min: 2801, max: 2940 },
  { state: "SC", min: 29001, max: 29948 },
  { state: "SD", min: 57001, max: 57799 },
  { state: "TN", min: 37010, max: 38589 },
  { state: "TX", min: 73301, max: 73301 },
  { state: "TX", min: 75001, max: 75501 },
  { state: "TX", min: 75503, max: 79999 },
  { state: "TX", min: 88510, max: 88589 },
  { state: "UT", min: 84001, max: 84784 },
  { state: "VA", min: 20040, max: 20041 },
  { state: "VA", min: 20040, max: 20167 },
  { state: "VA", min: 20042, max: 20042 },
  { state: "VA", min: 22001, max: 24658 },
  { state: "VT", min: 5001, max: 5495 },
  { state: "VT", min: 5601, max: 5907 },
  { state: "WA", min: 98001, max: 99403 },
  { state: "WI", min: 53001, max: 54990 },
  { state: "WV", min: 24701, max: 26886 },
  { state: "WY", min: 82001, max: 83128 },
]

export default function stateByZipCode(zip) {
  const zipInt = parseInt(zip);
  const mapper = mappers.find(({ min, max }) => zipInt >= min && zipInt <= max);

  return mapper ? mapper.state : null;
}
